import { useState, useEffect } from 'react';

interface UseMobileReturn {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  screenWidth: number;
  screenHeight: number;
  orientation: 'portrait' | 'landscape';
}

const useMobile = (): UseMobileReturn => {
  const [screenData, setScreenData] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    orientation: window.innerWidth > window.innerHeight ? 'landscape' : 'portrait' as 'portrait' | 'landscape'
  });

  useEffect(() => {
    const updateScreenData = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      setScreenData({
        isMobile: width <= 768,
        isTablet: width > 768 && width <= 1024,
        isDesktop: width > 1024,
        screenWidth: width,
        screenHeight: height,
        orientation: width > height ? 'landscape' : 'portrait'
      });
    };

    // Обновляем данные при изменении размера окна
    window.addEventListener('resize', updateScreenData);
    
    // Обновляем данные при изменении ориентации
    window.addEventListener('orientationchange', () => {
      setTimeout(updateScreenData, 100);
    });

    // Инициализируем данные
    updateScreenData();

    return () => {
      window.removeEventListener('resize', updateScreenData);
      window.removeEventListener('orientationchange', updateScreenData);
    };
  }, []);

  return screenData;
};

export default useMobile;
